/**
 * Copyright © 2026 Adnuntius AS.
 * Generated by bin/generate-route-page-registry.mjs — do not edit by hand.
 */
import {Type} from '@angular/core';

import {AdUnitAnalysisPageComponent} from '../../ad-unit/ad-unit-analysis-page.component';
import {AdUnitEditPageComponent} from '../../ad-unit/ad-unit-edit-page.component';
import {AdUnitListPageComponent} from '../../ad-unit/ad-unit-list-page.component';
import {AdvertiserAnalysisPageComponent} from '../../advertiser/advertiser-analysis-page.component';
import {AdvertiserEditPageComponent} from '../../advertiser/advertiser-edit-page.component';
import {AdvertiserItemPageComponent} from '../../advertiser/advertiser-item-page.component';
import {AdvertiserListPageComponent} from '../../advertiser/advertiser-list-page.component';
import {ApiKeyEditPageComponent} from '../../admin/api-key/api-key-edit-page.component';
import {ApiKeyListPageComponent} from '../../admin/api-key/api-key-list-page.component';
import {ApiKeyRoutePageComponent} from '../../admin/api-key/api-key-route-page.component';
import {AxLineItemListPageComponent} from '../../campaign/ax-line-item-list-page.component';
import {AxReviewListPageComponent} from '../../review/ax-review-list-page.component';
import {BlocklistEditPageComponent} from '../../blocklist/blocklist-edit-page.component';
import {BlocklistListPageComponent} from '../../blocklist/blocklist-list-page.component';
import {BlocklistRoutePageComponent} from '../../blocklist/blocklist-route-page.component';
import {CampaignAnalysisPageComponent} from '../../campaign/campaign-analysis-page.component';
import {CampaignEditPageComponent} from '../../campaign/campaign-edit-page.component';
import {CampaignListPageComponent} from '../../campaign/campaign-list-page.component';
import {CdnUploadEditPageComponent} from '../../admin/cdn-upload/cdn-upload-edit-page.component';
import {CdnUploadListPageComponent} from '../../admin/cdn-upload/cdn-upload-list-page.component';
import {CdnUploadRoutePageComponent} from '../../admin/cdn-upload/cdn-upload-route-page.component';
import {ContextServiceConfigurationEditPageComponent} from '../../admin/context-service-configuration/context-service-configuration-edit-page.component';
import {ContextServiceConfigurationListPageComponent} from '../../admin/context-service-configuration/context-service-configuration-list-page.component';
import {CouponEditPageComponent} from '../../admin/coupon/coupon-edit-page.component';
import {CouponListPageComponent} from '../../admin/coupon/coupon-list-page.component';
import {CouponRoutePageComponent} from '../../admin/coupon/coupon-route-page.component';
import {CreativeEditPageComponent} from '../../creative/creative-edit-page.component';
import {CreativeListPageComponent} from '../../creative/creative-list-page.component';
import {CreativeSetAnalysisPageComponent} from '../../creative-set/creative-set-analysis-page.component';
import {CreativeSetContextRoutePageComponent} from '../../creative-set/creative-set-context-route-page.component';
import {CreativeSetEditPageComponent} from '../../creative-set/creative-set-edit-page.component';
import {CreativeSetItemPageComponent} from '../../creative-set/creative-set-item-page.component';
import {CreativeSetListPageComponent} from '../../creative-set/creative-set-list-page.component';
import {CreativeSetRoutePageComponent} from '../../creative-set/creative-set-route-page.component';
import {CustomEventEditPageComponent} from '../../admin/custom-event/custom-event-edit-page.component';
import {CustomEventListPageComponent} from '../../admin/custom-event/custom-event-list-page.component';
import {CustomEventRoutePageComponent} from '../../admin/custom-event/custom-event-route-page.component';
import {DataExportEditPageComponent} from '../../admin/data-export/data-export-edit-page.component';
import {DataExportListPageComponent} from '../../admin/data-export/data-export-list-page.component';
import {EarningsAccountAnalysisPageComponent} from '../../earnings-account/earnings-account-analysis-page.component';
import {EarningsAccountEditPageComponent} from '../../earnings-account/earnings-account-edit-page.component';
import {EarningsAccountListPageComponent} from '../../earnings-account/earnings-account-list-page.component';
import {ElectionsListPageComponent} from '../../base/simple/elections-list-page.component';
import {EmailTemplateEditPageComponent} from '../../admin/email-template/email-template-edit-page.component';
import {EmailTemplateListPageComponent} from '../../admin/email-template/email-template-list-page.component';
import {EmailTemplateRoutePageComponent} from '../../admin/email-template/email-template-route-page.component';
import {EmailTranslationEditPageComponent} from '../../admin/email-translation/email-translation-edit-page.component';
import {EmailTranslationListPageComponent} from '../../admin/email-translation/email-translation-list-page.component';
import {EmailTranslationRoutePageComponent} from '../../admin/email-translation/email-translation-route-page.component';
import {ExternalAdUnitAnalysisPageComponent} from '../../external-ad-unit/external-ad-unit-analysis-page.component';
import {ExternalAdUnitEditPageComponent} from '../../external-ad-unit/external-ad-unit-edit-page.component';
import {ExternalAdUnitListPageComponent} from '../../external-ad-unit/external-ad-unit-list-page.component';
import {ExternalAdUnitRoutePageComponent} from '../../external-ad-unit/external-ad-unit-route-page.component';
import {ExternalDemandSourceAnalysisPageComponent} from '../../admin/external-demand-source/external-demand-source-analysis-page.component';
import {ExternalDemandSourceEditPageComponent} from '../../admin/external-demand-source/external-demand-source-edit-page.component';
import {ExternalDemandSourceItemPageComponent} from '../../admin/external-demand-source/external-demand-source-item-page.component';
import {ExternalDemandSourceListPageComponent} from '../../admin/external-demand-source/external-demand-source-list-page.component';
import {ExternalDemandSourceRoutePageComponent} from '../../admin/external-demand-source/external-demand-source-route-page.component';
import {FieldsRoutePageComponent} from '../../fields/fields-route-page.component';
import {FolderAnalysisPageComponent} from '../../folder/folder-analysis-page.component';
import {FolderContextRoutePageComponent} from '../../folder/folder-context-route-page.component';
import {FolderEditPageComponent} from '../../folder/folder-edit-page.component';
import {FolderItemPageComponent} from '../../folder/folder-item-page.component';
import {FolderListPageComponent} from '../../folder/folder-list-page.component';
import {FolderRoutePageComponent} from '../../folder/folder-route-page.component';
import {FolioContextRoutePageComponent} from '../../folio/folio-context-route-page.component';
import {FolioEditPageComponent} from '../../folio/folio-edit-page.component';
import {FolioItemPageComponent} from '../../folio/folio-item-page.component';
import {FolioListPageComponent} from '../../folio/folio-list-page.component';
import {FolioRoutePageComponent} from '../../folio/folio-route-page.component';
import {InvoiceTranslationEditPageComponent} from '../../invoice-translation/invoice-translation-edit-page.component';
import {InvoiceTranslationListPageComponent} from '../../invoice-translation/invoice-translation-list-page.component';
import {InvoiceTranslationRoutePageComponent} from '../../invoice-translation/invoice-translation-route-page.component';
import {LayoutContextRoutePageComponent} from '../../admin/layout/layout-context-route-page.component';
import {LayoutEditPageComponent} from '../../admin/layout/layout-edit-page.component';
import {LayoutExampleEditPageComponent} from '../../admin/layout-example/layout-example-edit-page.component';
import {LayoutExampleListPageComponent} from '../../admin/layout-example/layout-example-list-page.component';
import {LayoutExampleRoutePageComponent} from '../../admin/layout-example/layout-example-route-page.component';
import {LayoutIncludeEditPageComponent} from '../../admin/layout-include/layout-include-edit-page.component';
import {LayoutIncludeListPageComponent} from '../../admin/layout-include/layout-include-list-page.component';
import {LayoutIncludeRoutePageComponent} from '../../admin/layout-include/layout-include-route-page.component';
import {LayoutListPageComponent} from '../../admin/layout/layout-list-page.component';
import {LayoutRoutePageComponent} from '../../admin/layout/layout-route-page.component';
import {LibraryCreativeEditPageComponent} from '../../library-creative/library-creative-edit-page.component';
import {LibraryCreativeListPageComponent} from '../../library-creative/library-creative-list-page.component';
import {LineItemAnalysisPageComponent} from '../../line-item/line-item-analysis-page.component';
import {LineItemEditPageComponent} from '../../line-item/line-item-edit-page.component';
import {LineItemListPageComponent} from '../../line-item/line-item-list-page.component';
import {LineItemTemplateAnalysisPageComponent} from '../../line-item/line-item-template-analysis-page.component';
import {LineItemTemplateListPageComponent} from '../../line-item/line-item-template-list-page.component';
import {MappingRoutePageComponent} from '../../mapping/mapping-route-page.component';
import {MarketplaceProductEditPageComponent} from '../../admin/marketplace-product/marketplace-product-edit-page.component';
import {MarketplaceProductListPageComponent} from '../../admin/marketplace-product/marketplace-product-list-page.component';
import {MarketplaceProductRoutePageComponent} from '../../admin/marketplace-product/marketplace-product-route-page.component';
import {NotificationPreferencesEditPageComponent} from '../../admin/notification-preferences/notification-preferences-edit-page.component';
import {OrderAnalysisPageComponent} from '../../order/order-analysis-page.component';
import {OrderEditPageComponent} from '../../order/order-edit-page.component';
import {OrderItemPageComponent} from '../../order/order-item-page.component';
import {OrderListPageComponent} from '../../order/order-list-page.component';
import {PaymentListPageComponent} from '../../payment/payment-list-page.component';
import {PaymentRoutePageComponent} from '../../payment/payment-route-page.component';
import {PoliticalCampaignEditPageComponent} from '../../political-campaign/political-campaign-edit-page.component';
import {PoliticalCampaignListPageComponent} from '../../political-campaign/political-campaign-list-page.component';
import {PoliticalCampaignRoutePageComponent} from '../../political-campaign/political-campaign-route-page.component';
import {PoliticalEntityCampaignsPanelComponent} from '../../political-entity/political-entity-campaigns-panel.component';
import {PoliticalEntityEditPageComponent} from '../../political-entity/political-entity-edit-page.component';
import {PoliticalEntityListPageComponent} from '../../political-entity/political-entity-list-page.component';
import {PoliticalEntityRoutePageComponent} from '../../political-entity/political-entity-route-page.component';
import {PrintLineItemEditPageComponent} from '../../print-line-item/print-line-item-edit-page.component';
import {PrintLineItemListPageComponent} from '../../print-line-item/print-line-item-list-page.component';
import {ProductEditPageComponent} from '../../admin/product/product-edit-page.component';
import {ProductListPageComponent} from '../../admin/product/product-list-page.component';
import {ProductRoutePageComponent} from '../../admin/product/product-route-page.component';
import {QueryRoutePageComponent} from '../../report/query/query-route-page.component';
import {ReachAnalysisPageComponent} from '../../reach-analysis/reach-analysis-page.component';
import {ReleaseNotesEditPageComponent} from '../../base/simple/release-notes-edit-page.component';
import {ReleaseNotesListPageComponent} from '../../base/simple/release-notes-list-page.component';
import {ReportListPageComponent} from '../../report/report-list-page.component';
import {ReportRoutePageComponent} from '../../report/report-route-page.component';
import {ReportScheduleEditPageComponent} from '../../report-schedule/report-schedule-edit-page.component';
import {ReportScheduleListPageComponent} from '../../report-schedule/report-schedule-list-page.component';
import {ReportScheduleRoutePageComponent} from '../../report-schedule/report-schedule-route-page.component';
import {ReportTemplateContextRoutePageComponent} from '../../report-template/report-template-context-route-page.component';
import {ReportTemplateEditPageComponent} from '../../report-template/report-template-edit-page.component';
import {ReportTemplateListPageComponent} from '../../report-template/report-template-list-page.component';
import {ReportTemplateRoutePageComponent} from '../../report-template/report-template-route-page.component';
import {ReportTranslationEditPageComponent} from '../../report-translation/report-translation-edit-page.component';
import {ReportTranslationListPageComponent} from '../../report-translation/report-translation-list-page.component';
import {ReportTranslationRoutePageComponent} from '../../report-translation/report-translation-route-page.component';
import {RetailProductListPageComponent} from '../../retail-product/retail-product-list-page.component';
import {ReviewListPageComponent} from '../../review/review-list-page.component';
import {RoleAnalysisPageComponent} from '../../admin/role/role-analysis-page.component';
import {RoleEditPageComponent} from '../../admin/role/role-edit-page.component';
import {RoleItemPageComponent} from '../../admin/role/role-item-page.component';
import {RoleListPageComponent} from '../../admin/role/role-list-page.component';
import {RoleRoutePageComponent} from '../../admin/role/role-route-page.component';
import {RulesetEditPageComponent} from '../../ruleset/ruleset-edit-page.component';
import {RulesetListPageComponent} from '../../ruleset/ruleset-list-page.component';
import {RulesetRoutePageComponent} from '../../ruleset/ruleset-route-page.component';
import {SegmentContextRoutePageComponent} from '../../segment/segment-context-route-page.component';
import {SegmentEditPageComponent} from '../../segment/segment-edit-page.component';
import {SegmentItemPageComponent} from '../../segment/segment-item-page.component';
import {SegmentListPageComponent} from '../../segment/segment-list-page.component';
import {SegmentRoutePageComponent} from '../../segment/segment-route-page.component';
import {SiteAnalysisPageComponent} from '../../site/site-analysis-page.component';
import {SiteEditPageComponent} from '../../site/site-edit-page.component';
import {SiteGroupAnalysisPageComponent} from '../../site-group/site-group-analysis-page.component';
import {SiteGroupEditPageComponent} from '../../site-group/site-group-edit-page.component';
import {SiteGroupListPageComponent} from '../../site-group/site-group-list-page.component';
import {SiteListPageComponent} from '../../site/site-list-page.component';
import {TeamAnalysisPageComponent} from '../../admin/team/team-analysis-page.component';
import {TeamEditPageComponent} from '../../admin/team/team-edit-page.component';
import {TeamGroupAnalysisPageComponent} from '../../admin/team-group/team-group-analysis-page.component';
import {TeamGroupEditPageComponent} from '../../admin/team-group/team-group-edit-page.component';
import {TeamGroupItemPageComponent} from '../../admin/team-group/team-group-item-page.component';
import {TeamGroupListPageComponent} from '../../admin/team-group/team-group-list-page.component';
import {TeamGroupRoutePageComponent} from '../../admin/team-group/team-group-route-page.component';
import {TeamListPageComponent} from '../../admin/team/team-list-page.component';
import {ThirdPartyAudienceEditPageComponent} from '../../third-party-audience/third-party-audience-edit-page.component';
import {ThirdPartyAudienceEditRoutePageComponent} from '../../third-party-audience/third-party-audience-edit-route-page.component';
import {ThirdPartyAudienceItemPageComponent} from '../../third-party-audience/third-party-audience-item-page.component';
import {ThirdPartyAudienceListPageComponent} from '../../third-party-audience/third-party-audience-list-page.component';
import {ThirdPartyAudienceRoutePageComponent} from '../../third-party-audience/third-party-audience-route-page.component';
import {TierEditPageComponent} from '../../admin/tier/tier-edit-page.component';
import {TierListPageComponent} from '../../admin/tier/tier-list-page.component';
import {TierRoutePageComponent} from '../../admin/tier/tier-route-page.component';
import {TriggerContextRoutePageComponent} from '../../trigger/trigger-context-route-page.component';
import {TriggerEditPageComponent} from '../../trigger/trigger-edit-page.component';
import {TriggerItemPageComponent} from '../../trigger/trigger-item-page.component';
import {TriggerListPageComponent} from '../../trigger/trigger-list-page.component';
import {TriggerRoutePageComponent} from '../../trigger/trigger-route-page.component';
import {UserEditPageComponent} from '../../admin/user/user-edit-page.component';
import {UserListPageComponent} from '../../admin/user/user-list-page.component';
import {WorkspaceEditPageComponent} from '../../workspace/workspace-edit-page.component';
import {WorkspaceListPageComponent} from '../../workspace/workspace-list-page.component';
import {WorkspaceRoutePageComponent} from '../../workspace/workspace-route-page.component';

const ROUTE_PAGE_COMPONENTS: Record<string, Type<any>> = {
  'api-key-route': ApiKeyRoutePageComponent,
  'cdn-upload-route': CdnUploadRoutePageComponent,
  'coupon-route': CouponRoutePageComponent,
  'custom-event-route': CustomEventRoutePageComponent,
  'email-template-route': EmailTemplateRoutePageComponent,
  'email-translation-route': EmailTranslationRoutePageComponent,
  'external-demand-source-route': ExternalDemandSourceRoutePageComponent,
  'layout-example-route': LayoutExampleRoutePageComponent,
  'layout-include-route': LayoutIncludeRoutePageComponent,
  'layout-context-route': LayoutContextRoutePageComponent,
  'layout-route': LayoutRoutePageComponent,
  'marketplace-product-route': MarketplaceProductRoutePageComponent,
  'product-route': ProductRoutePageComponent,
  'role-route': RoleRoutePageComponent,
  'team-group-route': TeamGroupRoutePageComponent,
  'tier-route': TierRoutePageComponent,
  'blocklist-route': BlocklistRoutePageComponent,
  'creative-set-context-route': CreativeSetContextRoutePageComponent,
  'creative-set-route': CreativeSetRoutePageComponent,
  'external-ad-unit-route': ExternalAdUnitRoutePageComponent,
  'fields-route': FieldsRoutePageComponent,
  'folder-context-route': FolderContextRoutePageComponent,
  'folder-route': FolderRoutePageComponent,
  'folio-context-route': FolioContextRoutePageComponent,
  'folio-route': FolioRoutePageComponent,
  'invoice-translation-route': InvoiceTranslationRoutePageComponent,
  'mapping-route': MappingRoutePageComponent,
  'payment-route': PaymentRoutePageComponent,
  'political-campaign-route': PoliticalCampaignRoutePageComponent,
  'political-entity-route': PoliticalEntityRoutePageComponent,
  'report-schedule-route': ReportScheduleRoutePageComponent,
  'report-template-context-route': ReportTemplateContextRoutePageComponent,
  'report-template-route': ReportTemplateRoutePageComponent,
  'report-translation-route': ReportTranslationRoutePageComponent,
  'query-route': QueryRoutePageComponent,
  'report-route': ReportRoutePageComponent,
  'ruleset-route': RulesetRoutePageComponent,
  'segment-context-route': SegmentContextRoutePageComponent,
  'segment-route': SegmentRoutePageComponent,
  'third-party-audience-edit-route': ThirdPartyAudienceEditRoutePageComponent,
  'third-party-audience-route': ThirdPartyAudienceRoutePageComponent,
  'trigger-context-route': TriggerContextRoutePageComponent,
  'trigger-route': TriggerRoutePageComponent,
  'workspace-route': WorkspaceRoutePageComponent,
};

export function getRoutePageComponent(key: string): Type<any> | undefined {
  return ROUTE_PAGE_COMPONENTS[key];
}

const LIST_PAGE_COMPONENTS: Record<string, Type<any>> = {
  'ad-unit-list': AdUnitListPageComponent,
  'api-key-list': ApiKeyListPageComponent,
  'cdn-upload-list': CdnUploadListPageComponent,
  'context-service-configuration-list': ContextServiceConfigurationListPageComponent,
  'coupon-list': CouponListPageComponent,
  'custom-event-list': CustomEventListPageComponent,
  'data-export-list': DataExportListPageComponent,
  'email-template-list': EmailTemplateListPageComponent,
  'email-translation-list': EmailTranslationListPageComponent,
  'external-demand-source-list': ExternalDemandSourceListPageComponent,
  'layout-example-list': LayoutExampleListPageComponent,
  'layout-include-list': LayoutIncludeListPageComponent,
  'layout-list': LayoutListPageComponent,
  'marketplace-product-list': MarketplaceProductListPageComponent,
  'product-list': ProductListPageComponent,
  'role-list': RoleListPageComponent,
  'team-group-list': TeamGroupListPageComponent,
  'team-list': TeamListPageComponent,
  'tier-list': TierListPageComponent,
  'user-list': UserListPageComponent,
  'advertiser-list': AdvertiserListPageComponent,
  'elections-list': ElectionsListPageComponent,
  'release-notes-list': ReleaseNotesListPageComponent,
  'blocklist-list': BlocklistListPageComponent,
  'ax-line-item-list': AxLineItemListPageComponent,
  'campaign-list': CampaignListPageComponent,
  'creative-set-list': CreativeSetListPageComponent,
  'creative-list': CreativeListPageComponent,
  'earnings-account-list': EarningsAccountListPageComponent,
  'external-ad-unit-list': ExternalAdUnitListPageComponent,
  'folder-list': FolderListPageComponent,
  'folio-list': FolioListPageComponent,
  'invoice-translation-list': InvoiceTranslationListPageComponent,
  'library-creative-list': LibraryCreativeListPageComponent,
  'line-item-list': LineItemListPageComponent,
  'line-item-template-list': LineItemTemplateListPageComponent,
  'order-list': OrderListPageComponent,
  'payment-list': PaymentListPageComponent,
  'political-campaign-list': PoliticalCampaignListPageComponent,
  'political-entity-list': PoliticalEntityListPageComponent,
  'print-line-item-list': PrintLineItemListPageComponent,
  'report-schedule-list': ReportScheduleListPageComponent,
  'report-template-list': ReportTemplateListPageComponent,
  'report-translation-list': ReportTranslationListPageComponent,
  'report-list': ReportListPageComponent,
  'retail-product-list': RetailProductListPageComponent,
  'ax-review-list': AxReviewListPageComponent,
  'review-list': ReviewListPageComponent,
  'ruleset-list': RulesetListPageComponent,
  'segment-list': SegmentListPageComponent,
  'site-group-list': SiteGroupListPageComponent,
  'site-list': SiteListPageComponent,
  'third-party-audience-list': ThirdPartyAudienceListPageComponent,
  'trigger-list': TriggerListPageComponent,
  'workspace-list': WorkspaceListPageComponent,
};

export function getListPageComponent(key: string): Type<any> | undefined {
  return LIST_PAGE_COMPONENTS[key];
}

const ITEM_PAGE_COMPONENTS: Record<string, Type<any>> = {
  'external-demand-source-item': ExternalDemandSourceItemPageComponent,
  'role-item': RoleItemPageComponent,
  'team-group-item': TeamGroupItemPageComponent,
  'advertiser-item': AdvertiserItemPageComponent,
  'creative-set-item': CreativeSetItemPageComponent,
  'folder-item': FolderItemPageComponent,
  'folio-item': FolioItemPageComponent,
  'order-item': OrderItemPageComponent,
  'segment-item': SegmentItemPageComponent,
  'third-party-audience-item': ThirdPartyAudienceItemPageComponent,
  'trigger-item': TriggerItemPageComponent,
};

export function getItemPageComponent(key: string): Type<any> | undefined {
  return ITEM_PAGE_COMPONENTS[key];
}

const EDIT_PAGE_COMPONENTS: Record<string, Type<any>> = {
  'ad-unit-analysis-edit': AdUnitAnalysisPageComponent,
  'ad-unit-edit': AdUnitEditPageComponent,
  'api-key-edit': ApiKeyEditPageComponent,
  'cdn-upload-edit': CdnUploadEditPageComponent,
  'context-service-configuration-edit': ContextServiceConfigurationEditPageComponent,
  'coupon-edit': CouponEditPageComponent,
  'custom-event-edit': CustomEventEditPageComponent,
  'data-export-edit': DataExportEditPageComponent,
  'email-template-edit': EmailTemplateEditPageComponent,
  'email-translation-edit': EmailTranslationEditPageComponent,
  'external-demand-source-analysis-edit': ExternalDemandSourceAnalysisPageComponent,
  'external-demand-source-edit': ExternalDemandSourceEditPageComponent,
  'layout-example-edit': LayoutExampleEditPageComponent,
  'layout-include-edit': LayoutIncludeEditPageComponent,
  'layout-edit': LayoutEditPageComponent,
  'marketplace-product-edit': MarketplaceProductEditPageComponent,
  'notification-preferences-edit': NotificationPreferencesEditPageComponent,
  'product-edit': ProductEditPageComponent,
  'role-analysis-edit': RoleAnalysisPageComponent,
  'role-edit': RoleEditPageComponent,
  'team-group-analysis-edit': TeamGroupAnalysisPageComponent,
  'team-group-edit': TeamGroupEditPageComponent,
  'team-analysis-edit': TeamAnalysisPageComponent,
  'team-edit': TeamEditPageComponent,
  'tier-edit': TierEditPageComponent,
  'user-edit': UserEditPageComponent,
  'advertiser-analysis-edit': AdvertiserAnalysisPageComponent,
  'advertiser-edit': AdvertiserEditPageComponent,
  'release-notes-edit': ReleaseNotesEditPageComponent,
  'blocklist-edit': BlocklistEditPageComponent,
  'campaign-analysis-edit': CampaignAnalysisPageComponent,
  'campaign-edit': CampaignEditPageComponent,
  'creative-set-analysis-edit': CreativeSetAnalysisPageComponent,
  'creative-set-edit': CreativeSetEditPageComponent,
  'creative-edit': CreativeEditPageComponent,
  'earnings-account-analysis-edit': EarningsAccountAnalysisPageComponent,
  'earnings-account-edit': EarningsAccountEditPageComponent,
  'external-ad-unit-analysis-edit': ExternalAdUnitAnalysisPageComponent,
  'external-ad-unit-edit': ExternalAdUnitEditPageComponent,
  'folder-analysis-edit': FolderAnalysisPageComponent,
  'folder-edit': FolderEditPageComponent,
  'folio-edit': FolioEditPageComponent,
  'invoice-translation-edit': InvoiceTranslationEditPageComponent,
  'library-creative-edit': LibraryCreativeEditPageComponent,
  'line-item-analysis-edit': LineItemAnalysisPageComponent,
  'line-item-edit': LineItemEditPageComponent,
  'line-item-template-analysis-edit': LineItemTemplateAnalysisPageComponent,
  'order-analysis-edit': OrderAnalysisPageComponent,
  'order-edit': OrderEditPageComponent,
  'political-campaign-edit': PoliticalCampaignEditPageComponent,
  'political-entity-campaigns-panel': PoliticalEntityCampaignsPanelComponent,
  'political-entity-edit': PoliticalEntityEditPageComponent,
  'print-line-item-edit': PrintLineItemEditPageComponent,
  'reach-analysis-edit': ReachAnalysisPageComponent,
  'report-schedule-edit': ReportScheduleEditPageComponent,
  'report-template-edit': ReportTemplateEditPageComponent,
  'report-translation-edit': ReportTranslationEditPageComponent,
  'ruleset-edit': RulesetEditPageComponent,
  'segment-edit': SegmentEditPageComponent,
  'site-group-analysis-edit': SiteGroupAnalysisPageComponent,
  'site-group-edit': SiteGroupEditPageComponent,
  'site-analysis-edit': SiteAnalysisPageComponent,
  'site-edit': SiteEditPageComponent,
  'third-party-audience-edit': ThirdPartyAudienceEditPageComponent,
  'trigger-edit': TriggerEditPageComponent,
  'workspace-edit': WorkspaceEditPageComponent,
};

export function getEditPageComponent(key: string): Type<any> | undefined {
  return EDIT_PAGE_COMPONENTS[key];
}

const CONTEXT_ROUTE_PAGE_COMPONENTS: Record<string, Type<any>> = {
  'layout-context-route': LayoutContextRoutePageComponent,
  'creative-set-context-route': CreativeSetContextRoutePageComponent,
  'folder-context-route': FolderContextRoutePageComponent,
  'folio-context-route': FolioContextRoutePageComponent,
  'report-template-context-route': ReportTemplateContextRoutePageComponent,
  'segment-context-route': SegmentContextRoutePageComponent,
  'trigger-context-route': TriggerContextRoutePageComponent,
};

export function getContextRoutePageComponent(key: string): Type<any> | undefined {
  return CONTEXT_ROUTE_PAGE_COMPONENTS[key];
}

